export const styleTagMap = {
  'darkf': 'Dark Fantasy',
  '3d': '3D',
  'ancient': 'Ancient',
  'realistic': 'Default'
};

export const getDisplayStyle = (dbStyle) => {
  return styleTagMap[dbStyle] || null;
}; 